export const LOCAL_STORAGE_KEYS = {
    "PREVIOUS_URL": "PREVIOUS_URL",
    "PROBLEM_TEMP_DATA": "PROBLEM_TEMP_DATA"
}